import type { GlobalSettings } from '../components/services/GlobalSettingsService';

export const DEFAULT_GLOBAL_SETTINGS: GlobalSettings = {
  timesheet_split_hours_across_calendar_days: false,
  two_factor_authentication: false,
  plan_dates_department_check: true,
  distance_balanced_assignment: false,
  taskType_department_check: true,
  department_assignment_schedule: null,
  person_shift_restrictions: {
    maxMonthlyScheduledHours: 500,
    maxConsecutiveDaysWithShifts: 100
  }
};
